import { Component, OnInit } from '@angular/core';
import { AngularFireDatabase, FirebaseObjectObservable } from 'angularfire2/database';
import { MdSnackBar } from '@angular/material';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.css']
})
export class SettingsComponent implements OnInit {

  loading: boolean = true;
  notificationPhone: string;
  error: string;

  constructor(
    public snackbar:  MdSnackBar,
    private db:       AngularFireDatabase
  ) {}

  ngOnInit() {
    this.db.object('/config/notificationPhone').subscribe(
      data => {
        this.notificationPhone = data.$value;
        this.loading = false;
      }
    );
  }

  updateNotificationPhone(event) {
    event.preventDefault();
    this.db.object('/config/').update( { 'notificationPhone': this.notificationPhone } )
      .then(data    => this.displaySaveSucess('Notification phone number'))
      .catch(error  => console.log(error));
  }

  private displaySaveSucess(setting: string): void {
    this.snackbar.open(setting + ' saved.', '', {
      duration: 2000
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/settings/settings.component.ts